'use client';

export { default } from './SpeedDial';
export { default as speedDialClasses } from './speedDialClasses';
export * from './speedDialClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/SpeedDial/index.js
// module id = 954
// module chunks = 25